'use client';
import React, { useState, useEffect, useRef } from 'react';

interface Partner {
  num: string;
  category: string;
  name: string;
}

const partners: Partner[] = [
  { num: '01', category: 'Joint Venture Partner', name: 'TotalEnergies' },
  { num: '02', category: 'Joint Venture Partner', name: 'CNOOC Uganda' },
  { num: '03', category: 'Pipeline Partner', name: 'EACOP Co. Ltd' },
  { num: '04', category: 'Regional Partner', name: 'TPDC Tanzania' },
  { num: '05', category: 'Technical Partner', name: 'Baker Hughes' },
  { num: '06', category: 'Regulator', name: 'Petroleum Authority of Uganda' },
  { num: '07', category: 'Government', name: 'Ministry of Energy & Mineral Development' },
  { num: '08', category: 'Government', name: 'Ministry of Finance, Planning & Economic Development' },
  { num: '09', category: 'Government', name: 'Bank of Uganda' },
  { num: '10', category: 'Regulator', name: 'NEMA' },
  { num: '11', category: 'Transparency', name: 'UGEITI' },
  { num: '12', category: 'Regulator', name: 'PPDA' },
];

export default function PartnersSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-[#F8F9FA]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        {/* Header */}
        <div
          className="mb-16 max-w-3xl"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'none' : 'translateY(20px)',
            transition: 'opacity 0.6s ease, transform 0.6s ease',
          }}
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="font-mono text-xs text-[#CC0000] tracking-[0.2em]">[ 06 ]</span>
            <div className="h-[1px] w-12 bg-[#CC0000]" />
            <span className="text-[#CC0000] text-xs font-bold uppercase tracking-[0.2em]" style={{ fontFamily: 'Inter, sans-serif' }}>Our Partners</span>
          </div>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0F0F0F] leading-[1.05] tracking-tight"
            style={{ fontFamily: 'Inter, sans-serif', letterSpacing: '-0.025em' }}
          >
            Working <span className="text-[#CC0000]">together</span>
          </h2>
          <p className="text-lg text-gray-600 mt-5" style={{ fontFamily: 'Inter, sans-serif' }}>
            UNOC collaborates with leading international operators, regulators, and government institutions to deliver Uganda&apos;s petroleum value chain.
          </p>
        </div>

        {/* Partners grid */}
        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-0 border-t border-l border-gray-200"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'none' : 'translateY(20px)',
            transition: 'opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s',
          }}
        >
          {partners.map((partner, i) => (
            <div
              key={i}
              className="group bg-white border-r border-b border-gray-200 p-6 lg:p-8 hover:bg-[#0F0F0F] transition-colors duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <span className="font-mono text-xs text-gray-300 group-hover:text-[#CC0000] tracking-[0.2em] transition-colors">
                  {partner.num}
                </span>
                <div className="w-1.5 h-1.5 rounded-full bg-[#CC0000] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <p className="font-mono text-[10px] text-gray-400 group-hover:text-gray-500 uppercase tracking-[0.15em] mb-2 transition-colors">
                {partner.category}
              </p>
              <p
                className="text-sm font-bold text-[#0F0F0F] group-hover:text-white leading-snug transition-colors"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {partner.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
